import { useState, useCallback, useEffect } from 'react';

export const usePathDetails = ({ solveResult, onUpdateVisiblePath }) => {
  const [showPathDetails, setShowPathDetails] = useState(false);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [currentVisiblePath, setCurrentVisiblePath] = useState([]);

  // Toggle path details section
  const togglePathDetails = (e) => {
    if (e) e.preventDefault();
    
    // Toggle detail visibility state
    const newShowPathDetails = !showPathDetails;

    // First update the UI state
    setShowPathDetails(newShowPathDetails);
    
    // Reset to first step when showing details
    if (newShowPathDetails) {
      setCurrentStepIndex(0);
      
      // When enabling path details, get the initial step path
      if (solveResult && solveResult.path) {
        // Get the first step's partial path (first point only)
        const partialPath = solveResult.path.slice(0, 1);
        setCurrentVisiblePath(partialPath);
        
        // Only update if paths are different
        if (partialPath.length > 0 && onUpdateVisiblePath && typeof onUpdateVisiblePath === 'function') {

          onUpdateVisiblePath(partialPath);
        }
      }
    } else {
      // When disabling path details, restore full path
      if (solveResult && solveResult.path) {
        setCurrentVisiblePath(solveResult.path);
        
        // Notify parent component to restore full path visualization
        if (onUpdateVisiblePath && typeof onUpdateVisiblePath === 'function') {

          // Pass null to indicate use original path
          onUpdateVisiblePath(null);
        }
      }
    }
  };

  // Handle step change with debounce
  const handleStepChange = useCallback((stepIndex) => {

    // Update current step index immediately for UI
    setCurrentStepIndex(stepIndex);
  }, []);

  // Add a cleanup effect to reset visualization when unmounting
  useEffect(() => {
    return () => {
      // Reset visualization when component unmounts
      if (onUpdateVisiblePath) {
        onUpdateVisiblePath(null);
      }
    };
  }, [onUpdateVisiblePath]);

  return {
    showPathDetails,
    currentStepIndex,
    currentVisiblePath,
    setShowPathDetails,
    togglePathDetails,
    handleStepChange
  };
}; 